import { Translations } from "../services/i18n-manager";

// English translations
const en: Translations = {
  // Navigation
  "nav.home": "Home",
  "nav.products": "Products",
  "nav.contact": "Contact",
  "nav.account": "Account",
  "nav.cart": "Cart",
  "nav.login": "Sign In",
  "nav.logout": "Sign Out",
  "nav.register": "Register",

  // Page metadata
  "page.title": "Novi Prints - 3D Printing Solutions",
  "page.description":
    "Professional 3D printing services with custom designs and high-quality materials.",

  // Hero section
  "hero.title": "Custom 3D Printing",
  "hero.subtitle": "Transform Your Ideas Into Reality",
  "hero.description":
    "High-quality 3D printing services with precision craftsmanship and custom designs for your projects.",
  "hero.cta": "Explore Products",
  "hero.title_line1": "Custom",
  "hero.title_line2": "3D Printing",

  // Categories
  "categories.title": "Categories",
  "categories.all": "All Products",
  "categories.figures": "Figures",
  "categories.prototypes": "Prototypes",
  "categories.decorations": "Decorations",
  "categories.tools": "Tools",

  // Products
  "products.loading": "Loading products...",
  "products.not_found": "No products found",
  "products.try_different_category": "Try a different category",
  "products.view_details": "View Details",
  "products.add_to_cart": "Add to Cart",
  "products.in_cart": "In Cart",
  "products.out_of_stock": "Out of Stock",
  "products.price": "Price",
  "products.quantity": "Quantity",
  "products.options": "Options",
  "products.select_options_required":
    "Please select product options before adding to cart",

  // Product dialog
  "product.quantity": "Quantity:",
  "product.details": "Product Details",
  "product.no_specifications": "No specifications available",
  "product.add_to_cart": "Add to Cart",
  "product.in_cart": "In Cart",
  "product.options.color": "Color",
  "product.options.size": "Size",
  "product.options.material": "Material",
  "product.options.finish": "Finish",
  "product.specs.dimensions": "Dimensions",
  "product.specs.weight": "Weight",
  "product.specs.material": "Material",
  "product.specs.color": "Color",
  "product.specs.finish": "Finish",
  "product.specs.print_time": "Print Time",
  "product.specs.layer_height": "Layer Height",
  "product.specs.infill": "Infill",

  // Cart
  "cart.title": "Shopping Cart",
  "cart.empty": "Your cart is empty",
  "cart.empty_description": "Add some products to get started",
  "cart.subtotal": "Subtotal",
  "cart.shipping": "Shipping",
  "cart.total": "Total",
  "cart.checkout": "Checkout",
  "cart.continue_shopping": "Continue Shopping",
  "cart.remove_item": "Remove Item",
  "cart.update_quantity": "Update Quantity",
  "cart.item_removed": "Item removed from cart",

  // Checkout
  "checkout.title": "Checkout",
  "checkout.step.customer_info": "Customer Info",
  "checkout.step.payment": "Payment",
  "checkout.step.confirmation": "Confirmation",
  "checkout.email": "Email Address",
  "checkout.name": "Full Name",
  "checkout.address": "Address",
  "checkout.city": "City",
  "checkout.postal": "Postal Code",
  "checkout.country": "Country",
  "checkout.same_billing": "Billing address same as shipping",
  "checkout.guest_checkout": "Guest Checkout",
  "checkout.login": "Login",
  "checkout.continue_to_payment": "Continue to Payment",
  "checkout.back": "Back",
  "checkout.complete_order": "Complete Order",
  "checkout.cancel": "Cancel",
  "checkout.continue_shopping": "Continue Shopping",
  "checkout.order_details": "Order Details",
  "checkout.order_number": "Order Number",
  "checkout.total_amount": "Total Amount",
  "checkout.confirmation_email":
    "You will receive a confirmation email shortly.",
  "checkout.confirmation": "Confirmation",
  "checkout.guest": "Guest Checkout",
  "checkout.login_prompt": "Already have an account?",
  "checkout.billing_address": "Billing Address",
  "checkout.shipping_address": "Shipping Address",
  "checkout.same_as_billing": "Same as billing address",
  "checkout.payment_method": "Payment Method",
  "checkout.card_number": "Card Number",
  "checkout.expiry_date": "Expiry Date",
  "checkout.cvv": "CVV",
  "checkout.cardholder_name": "Cardholder Name",
  "checkout.place_order": "Place Order",
  "checkout.order_success": "Order Received!",
  "checkout.login_required": "Please log in to continue with checkout",
  "checkout.payment_error": "Failed to initialize payment. Please try again.",
  "checkout.payment_not_ready": "Payment system not ready. Please try again.",
  "checkout.processing": "Processing...",
  "checkout.payment_failed": "Payment failed. Please try again.",
  "checkout.order_confirmed": "Order confirmed! Thank you for your purchase.",
  "checkout.order_failed": "Order creation failed. Please contact support.",
  "checkout.minimum_amount": "Minimum order amount is 3.00 SEK",
  // duplicate removed

  // Account
  "account.title": "My Account",
  "account.profile": "Profile",
  "account.orders": "Orders",
  "account.settings": "Settings",
  "account.logout": "Sign Out",
  "account.edit_profile": "Edit Profile",
  "account.save_changes": "Save Changes",
  "account.cancel": "Cancel",
  "account.name": "Name",
  "account.email": "Email",
  "account.phone": "Phone",
  "account.address": "Address",
  "account.city": "City",
  "account.postal_code": "Postal Code",
  "account.country": "Country",
  "account.email_readonly": "Email address cannot be changed",
  "account.logout_description": "Sign out of your account",

  // Orders
  "orders.title": "My Orders",
  "orders.no_orders": "No orders yet",
  "orders.order_date": "Order Date",
  "orders.order_status": "Status",
  "orders.order_total": "Total",
  "orders.tracking_number": "Tracking Number",
  "orders.view_order": "View Order",
  "orders.status.pending": "Pending",
  "orders.status.processing": "Processing",
  "orders.status.paid": "Paid",
  "orders.status.shipped": "Shipped",
  "orders.status.delivered": "Delivered",
  "orders.status.cancelled": "Cancelled",

  // Materials
  "materials.title": "Our Materials",
  "materials.description":
    "We use Polyterra PLA, a premium eco-friendly material for all our prints.",
  "materials.quality.title": "Premium Quality",
  "materials.quality.description":
    "Polyterra PLA is a bioplastic derived from renewable resources like corn and sugarcane. It offers enhanced toughness and a matte finish, ensuring durability and aesthetic appeal.",
  "materials.environmental.title": "Environmental Benefits",
  "materials.environmental.description":
    "By incorporating organic materials, Polyterra PLA reduces plastic content by approximately 40%. For every spool sold, a tree is planted, contributing to carbon offsetting and promoting sustainability.",
  "materials.health.title": "Health & Safety",
  "materials.health.description":
    "Polyterra PLA is biodegradable under industrial composting conditions, breaking down into carbon dioxide, water, biomass, and mineral salts without leaving toxic residues. Safe for both users and the environment.",

  // About
  "about.title": "About Us",
  "about.paragraph1":
    "Novi is a family-owned business passionate about crafting DIY solutions for miniature houses and miniature furniture. Our journey began with a heartfelt project—a custom miniature house for our son—which ignited our commitment to bringing joy through miniatures.",
  "about.paragraph2":
    "We offer a range of products, from miniature furniture to bespoke miniatures, and are dedicated to providing custom solutions tailored to your unique needs. Whether you're looking for DIY ideas for miniature furniture, complete miniature houses, or other specialized prints, we're here to help bring your vision to life.",
  "about.paragraph3":
    "Our goal is to provide custom solutions for those in need, such as miniatures, modeling of houses, furniture, and more. Each project is crafted with care and attention to detail, aiming to deliver quality results that hopefully exceed expectations.",

  // Contact
  "contact.title": "Contact Us",
  "contact.subtitle": "Custom Print Request",
  "contact.description":
    "Have a custom design or need something specific? Send us your requirements and we'll provide a quote for your project.",
  "contact.name": "Name",
  "contact.email": "Email",
  "contact.message": "Message",
  "contact.files": "Files (STL, Images)",
  "contact.file_upload_hint": "Drag and drop files here or click to browse",
  "contact.file_types": "STL files, images (JPG, PNG, WebP)",
  "contact.send_request": "Send Request",
  "contact.success": "Request Sent!",
  "contact.success_message":
    "Thank you for your request. We will contact you within 24 hours.",
  "contact.selected_files": "Selected Files",

  // Authentication
  "auth.dialog_title": "Sign In",
  "auth.login": "Sign In",
  "auth.register": "Register",
  "auth.login_tab": "Login",
  "auth.register_tab": "Register",
  "auth.name": "Name",
  "auth.first_name": "First Name",
  "auth.last_name": "Last Name",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.confirm_password": "Confirm Password",
  "auth.forgot_password": "Forgot Password?",
  "auth.remember_me": "Remember Me",
  "auth.sign_in": "Sign In",
  "auth.create_account": "Create Account",
  "auth.already_have_account": "Already have an account?",
  "auth.dont_have_account": "Don't have an account?",
  "auth.login_success": "Login successful!",
  "auth.register_success": "Account created!",
  "auth.logout_success": "Logout successful!",
  "auth.address": "Address",
  "auth.city": "City",
  "auth.postal_code": "Postal Code",
  "auth.country": "Country",
  "auth.shipping_address": "Shipping Address",
  "auth.error.user_not_found": "No account found with this email address",
  "auth.error.wrong_password": "Incorrect password",
  "auth.error.invalid_credential": "Invalid email or password",
  "auth.error.email_already_in_use":
    "An account with this email already exists",
  "auth.error.weak_password": "Password should be at least 6 characters",
  "auth.error.invalid_email": "Invalid email address",
  "auth.error.user_disabled": "This account has been disabled",
  "auth.error.too_many_requests":
    "Too many failed attempts. Please try again later",
  "auth.error.network_error": "Network error. Please check your connection",
  "auth.error.configuration_not_found":
    "Authentication is not configured. Please contact support",
  "auth.error.operation_not_allowed":
    "This sign-in method is not enabled. Please contact support",
  "auth.error.generic": "An error occurred. Please try again",

  // GDPR
  "gdpr.data_export": "Export My Data",
  "gdpr.delete_account": "Delete Account",
  "gdpr.confirm_delete": "Delete your account?",
  "gdpr.cannot_be_undone": "This action cannot be undone.",
  "gdpr.data_exported": "Your data has been exported",
  "gdpr.account_deleted": "Your account has been deleted",
  "gdpr.title": "Data Management",
  "gdpr.description": "Manage your personal data according to GDPR",
  "gdpr.delete_warning": "All your data will be permanently deleted",

  // Policies
  privacy_policy_title: "Privacy Policy",
  privacy_policy_content:
    "We respect your privacy and protect your personal data according to GDPR...",
  cookie_policy_title: "Cookie Policy",
  cookie_policy_content: "We use cookies to enhance your experience...",
  terms_title: "Terms of Service",
  terms_content: "By using our website, you agree to these terms...",

  // Privacy Policy
  "privacy.section1_title": "Introduction",
  "privacy.section1_content":
    "Novi Prints ('we', 'our', or 'us') is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our services. Please read this privacy policy carefully. If you do not agree with the terms of this privacy policy, please do not access the site.",
  "privacy.section2_title": "Personal Data We Collect",
  "privacy.section2_content":
    "We collect information that you provide directly to us when you create an account, place an order, or contact us. This includes your name, email address, postal address (street address, city, postal code, and country), and password. When you place an order, we also collect payment information through our payment processor Stripe (we do not store your full payment card details). If you submit a contact form, we collect your name, email address, message, and any files you upload. We do not collect your phone number unless you provide it voluntarily in a contact message.",
  "privacy.section3_title": "How We Use Your Data",
  "privacy.section3_content":
    "We use the information we collect to process and fulfill your orders, communicate with you about your orders (including sending order confirmations and shipping notifications via email), respond to your contact inquiries, manage your account, improve our website and services, comply with legal obligations, and for other purposes disclosed to you at the time of collection. We do not send marketing emails or newsletters at this time.",
  "privacy.section4_title": "Data Sharing and Disclosure",
  "privacy.section4_content":
    "We share your payment information with Stripe, our payment processor, to process payments. Stripe handles all payment transactions and is PCI-DSS compliant. We use Firebase (Google) for authentication and database services, and SMTP email services (such as Resend, Postmark, or SendGrid) to send transactional emails. We do not sell your personal information to third parties. We may disclose your information if required by law or to protect our rights or the safety of our users. In the event of a business transfer or merger, your information may be transferred as part of that transaction.",
  "privacy.section5_title": "Data Storage and Security",
  "privacy.section5_content":
    "We implement appropriate technical and organizational security measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet or electronic storage is completely secure. We retain your personal data only for as long as necessary to fulfill the purposes outlined in this policy or as required by law.",
  "privacy.section6_title": "Your Rights Under GDPR",
  "privacy.section6_content":
    "If you are located in the European Economic Area, you have certain data protection rights, including the right to access, rectify, erase, restrict processing, object to processing, data portability, and to withdraw consent at any time. To exercise these rights, please contact us using the information provided in the Contact section. We will respond to your request within 30 days.",
  "privacy.section7_title": "Cookies and Tracking Technologies",
  "privacy.section7_content":
    "We use cookies and similar tracking technologies to track activity on our service and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our service. For more information, please review our Cookie Policy.",
  "privacy.section8_title": "Changes to This Privacy Policy",
  "privacy.section8_content":
    "We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the 'Last Updated' date. You are advised to review this Privacy Policy periodically for any changes.",
  "privacy.contact_title": "Contact Us",
  "privacy.contact_content":
    "If you have any questions about this Privacy Policy, please contact us at info@noviprints.com. We will make every effort to respond to your request promptly.",

  // Terms of Service
  "terms.section1_title": "Acceptance of Terms",
  "terms.section1_content":
    "By accessing and using the Novi Prints website and services, you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to abide by the above, please do not use this service. These Terms of Service apply to all users of the site, including without limitation users who are browsers, vendors, customers, merchants, and/or contributors of content.",
  "terms.section2_title": "Use of Service",
  "terms.section2_content":
    "You may use our website for lawful purposes only. You agree not to use our services to transmit, distribute, store, or destroy material in violation of any applicable law or regulation. Prohibited activities include, but are not limited to, unauthorized access to our systems, introduction of viruses or harmful code, interference with service operations, and violation of intellectual property rights.",
  "terms.section3_title": "Product Information and Pricing",
  "terms.section3_content":
    "We strive to provide accurate product descriptions, pricing, and availability information. However, we do not warrant that product descriptions or other content on this site is accurate, complete, reliable, current, or error-free. Prices are subject to change without notice. We reserve the right to correct any errors, inaccuracies, or omissions and to change or update information at any time without prior notice.",
  "terms.section4_title": "Orders and Payment",
  "terms.section4_content":
    "All orders placed through our website are subject to our acceptance. We reserve the right to refuse or cancel any order for any reason, including but not limited to product availability, errors in pricing or product information, or fraud. Payment must be received in advance before we process your order. We accept payment via credit card, debit card, and digital payment methods (such as Apple Pay and Google Pay) through our payment processor Stripe. All prices are in SEK (Swedish Krona) unless otherwise stated. The minimum order amount is 3.00 SEK.",
  "terms.section5_title": "Shipping and Delivery",
  "terms.section5_content":
    "Shipping costs will be displayed during checkout. As we are a small 3D printing business, please note that delivery times may vary depending on production time for custom items. Delivery times are estimates only and are not guaranteed. Risk of loss and title for products purchased pass to you upon delivery. We are not liable for any delays caused by shipping carriers or customs. International shipments may be subject to customs fees and import duties, which are the customer's responsibility.",
  "terms.section6_title": "Returns and Refunds",
  "terms.section6_content":
    "If you are not satisfied with your purchase, you may return it within 14 days of delivery in its original condition with proof of purchase. Custom or personalized 3D printed items may not be eligible for return unless defective, as each item is custom-made. To initiate a return, please contact us at info@noviprints.com. Refunds will be processed to the original payment method through Stripe within 14 business days of receiving the returned item.",
  "terms.section7_title": "Intellectual Property",
  "terms.section7_content":
    "All content included on this site, such as text, graphics, logos, images, and software, is the property of Novi Prints or its content suppliers and protected by copyright laws. You may not reproduce, distribute, modify, create derivative works from, publicly display, or otherwise use any content from this website without our express written permission.",
  "terms.section8_title": "Limitation of Liability",
  "terms.section8_content":
    "To the fullest extent permitted by applicable law, Novi Prints shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses resulting from your use of our services or products.",
  "terms.section9_title": "Modifications to Terms",
  "terms.section9_content":
    "We reserve the right, at our sole discretion, to modify or replace these Terms of Service at any time. If a revision is material, we will provide at least 30 days' notice prior to any new terms taking effect. Your continued use of our services after any changes constitutes acceptance of those changes.",
  "terms.contact_title": "Contact Information",
  "terms.contact_content":
    "If you have any questions about these Terms of Service, please contact us at info@noviprints.com. We will respond to your inquiry as soon as possible.",

  // Cookies
  "cookies.title": "We Use Cookies",
  "cookies.description":
    "We use cookies to enhance your experience and analyze our traffic. By continuing to use our site, you consent to our use of cookies.",
  "cookies.accept_all": "Accept All",
  "cookies.customize": "Customize",
  "cookies.necessary": "Necessary",
  "cookies.analytics": "Analytics",
  "cookies.marketing": "Marketing",
  "cookies.customize_title": "Cookie Settings",
  "cookies.customize_description":
    "Choose which types of cookies you want to accept:",
  "cookies.necessary_description":
    "These cookies are necessary for the website to function properly.",
  "cookies.analytics_description":
    "These cookies help us understand how visitors interact with the website.",
  "cookies.marketing_description":
    "These cookies are used to show relevant advertisements.",
  "cookies.save_preferences": "Save Preferences",
  "cookies.manage_preferences": "Manage Cookie Preferences",
  "cookies.what_are_cookies": "What Are Cookies?",
  "cookies.what_are_cookies_content":
    "Cookies are small text files that are placed on your computer or mobile device when you visit a website. Cookies are widely used to make websites work more efficiently and provide information to website owners. Cookies allow a website to recognize your device and store some information about your preferences or past actions.",
  "cookies.how_we_use_cookies": "How We Use Cookies",
  "cookies.how_we_use_cookies_content":
    "We use cookies and local storage to enable essential functions of the website, such as maintaining your login session, storing your cookie preferences, and saving your shopping cart. Currently, we only use necessary cookies to ensure the website functions properly. We do not currently implement analytics or marketing cookies, but we provide options for these in our cookie consent system should we add them in the future.",
  "cookies.cookie_types": "Types of Cookies We Use",
  "cookies.cookie_types_content": "We use the following types of cookies:",
  "cookies.necessary_details":
    "Necessary cookies and local storage are essential for the website to function properly. These include session management (keeping you logged in), storing your cookie consent preferences, and saving your shopping cart. These cookies cannot be disabled.",
  "cookies.analytics_details":
    "While we provide an option to accept analytics cookies, we do not currently implement any analytics tracking tools (such as Google Analytics). If we add analytics in the future, these cookies would help us understand how visitors interact with our website anonymously.",
  "cookies.marketing_details":
    "While we provide an option to accept marketing cookies, we do not currently implement any marketing or advertising tracking. If we add marketing tools in the future, these cookies would be used to deliver relevant content.",
  "cookies.third_party_title": "Third-Party Cookies",
  "cookies.third_party_content":
    "We use Stripe for payment processing, which may set cookies as part of their payment services. We also use Firebase for authentication and database services. We do not currently use third-party analytics or advertising cookies.",
  "cookies.retention_title": "Cookie Retention",
  "cookies.retention_content":
    "Different cookies and local storage data have different retention periods. Session cookies expire when you close your browser, while persistent cookies and local storage data (such as your cookie consent preferences) remain on your device until you clear your browser data or delete them manually. Your cookie consent preferences are stored in your browser's local storage until you revoke consent.",
  "cookies.manage_cookies": "Managing Your Cookie Preferences",
  "cookies.manage_cookies_content":
    "You can control and/or delete cookies as you wish. Most web browsers automatically accept cookies, but you can usually modify your browser settings to decline cookies if you prefer. You can also change your cookie preferences at any time using the cookie settings tool on our website. Please note that disabling certain cookies may affect the functionality of our website.",

  // Common
  "common.loading": "Loading...",
  "common.error": "An error occurred",
  "common.success": "Success!",
  "common.cancel": "Cancel",
  "common.confirm": "Confirm",
  "common.save": "Save",
  "common.edit": "Edit",
  "common.delete": "Delete",
  "common.close": "Close",
  "common.back": "Back",
  "common.next": "Next",
  "common.previous": "Previous",
  "common.search": "Search",
  "common.filter": "Filter",
  "common.sort": "Sort",
  "common.clear": "Clear",
  "common.reset": "Reset",
  "common.submit": "Submit",
  "common.required": "Required",
  "common.optional": "Optional",
  "common.yes": "Yes",
  "common.no": "No",
  "common.ok": "OK",
  "common.retry": "Try Again",

  // Accessibility
  "accessibility.title": "Accessibility Statement",
  "accessibility.section1_title": "Our Commitment",
  "accessibility.section1_content":
    "Novi Prints is committed to ensuring digital accessibility for people with disabilities. We are continually improving the user experience for everyone and applying the relevant accessibility standards to achieve WCAG 2.2 Level AA compliance.",
  "accessibility.section2_title": "Conformance Status",
  "accessibility.section2_content":
    "The Web Content Accessibility Guidelines (WCAG) defines requirements for designers and developers to improve accessibility for people with disabilities. It defines three levels of conformance: Level A, Level AA, and Level AAA. Novi Prints is partially conformant with WCAG 2.2 Level AA. Partially conformant means that some parts of the content do not fully conform to the accessibility standard.",
  "accessibility.section3_title": "Measures to Support Accessibility",
  "accessibility.section3_content":
    "Novi Prints takes the following measures to ensure accessibility: Include accessibility as part of our mission statement, include accessibility throughout our internal policies, provide continual accessibility training for our staff, assign clear accessibility goals and responsibilities, employ formal accessibility quality assurance methods, and include people with disabilities in our design personas.",
  "accessibility.section4_title": "Keyboard Navigation",
  "accessibility.section4_content":
    "All interactive elements can be accessed using a keyboard. Use Tab to navigate forward, Shift+Tab to navigate backward, Enter or Space to activate buttons, and Escape to close dialogs. Focus indicators are visible with a clear outline to show which element is currently focused.",
  "accessibility.section5_title": "Screen Reader Support",
  "accessibility.section5_content":
    "Our website is compatible with screen readers and assistive technologies. We use semantic HTML, ARIA labels for icon-only buttons, ARIA live regions for dynamic content announcements, proper heading hierarchy, and alt text for all images. Form fields are properly labeled and error messages are announced to screen readers.",
  "accessibility.section6_title": "Visual Accessibility",
  "accessibility.section6_content":
    "We maintain sufficient color contrast ratios (minimum 4.5:1 for normal text, 3:1 for large text) to meet WCAG AA standards. Text can be resized up to 200% without loss of functionality. We respect the 'prefers-reduced-motion' setting to reduce animations for users who prefer them. Interactive elements meet the minimum target size of 44x44 pixels for easy activation.",
  "accessibility.section7_title": "WCAG 2.2 Updates (2024-2025)",
  "accessibility.section7_content":
    "We have implemented the new WCAG 2.2 success criteria including: Focus Not Obscured (Enhanced) - ensuring focus indicators are always visible, Focus Not Obscured (Minimum) - focus indicators are at least partially visible, Minimum Target Size - interactive elements are at least 24x24 CSS pixels (we exceed this with 44x44), and Accessible Authentication - we provide methods that do not rely on cognitive function tests.",
  "accessibility.section8_title": "Known Issues and Limitations",
  "accessibility.section8_content":
    "Despite our best efforts to ensure accessibility, there may be some limitations. Some third-party content (such as Stripe payment forms) may have varying levels of accessibility. We are actively working with our service providers to improve this. If you notice any accessibility barriers, please contact us using the feedback form below.",
  "accessibility.section9_title": "Feedback",
  "accessibility.section9_content":
    "We welcome your feedback on the accessibility of Novi Prints. Please let us know if you encounter accessibility barriers by contacting us at info@noviprints.com. We aim to respond to accessibility feedback within 5 business days.",
  "accessibility.contact_title": "Contact Us",
  "accessibility.contact_content":
    "For questions or concerns about accessibility, please contact us at info@noviprints.com.",

  // Footer
  "footer.company": "Novi Prints",
  "footer.description":
    "Professional 3D printing services with precision and quality.",
  "footer.quick_links": "Quick Links",
  "footer.contact": "Contact",
  "footer.email": "Email",
  "footer.phone": "Phone",
  "footer.copyright": "© 2024 Novi Prints. All rights reserved.",
  "footer.privacy_policy": "Privacy Policy",
  "footer.cookie_policy": "Cookie Policy",
  "footer.terms_of_service": "Terms of Service",
  "footer.accessibility": "Accessibility",
  "footer.email_label": "Email:",
  "footer.phone_label": "Phone:",

  // Errors
  "error.network": "Network error. Please check your internet connection.",
  "error.server": "Server error. Please try again later.",
  "error.not_found": "Page not found.",
  "error.unauthorized": "You are not authorized to perform this action.",
  "error.validation": "Please check your information.",
  "error.file_too_large": "File is too large.",
  "error.invalid_file_type": "Invalid file type.",
  "error.upload_failed": "Upload failed.",
  "error.update_failed": "Update failed.",
  "error.load_orders": "Could not load orders.",
  "error.export_failed": "Export failed.",
  "error.delete_failed": "Delete failed.",
  "error.logout_failed": "Logout failed.",
  "error.load_categories": "Could not load categories.",
  "error.load_products": "Could not load products.",
  "error.submit_failed": "Submission failed.",

  // Success messages
  "success.item_added_to_cart": "Item added to cart",
  "success.order_placed": "Order placed",
  "success.profile_updated": "Profile updated",
  "success.password_changed": "Password changed",
  "success.email_sent": "Email sent",
  "success.file_uploaded": "File uploaded",
  "success.contact_submitted":
    "Thank you! Your request has been sent successfully. We'll get back to you within 24 hours.",

  // Order Confirmation
  "order_confirmation.title": "Order Confirmation",
  "order_confirmation.thank_you": "Thank you for your order!",
  "order_confirmation.greeting": "Dear {name},",
  "order_confirmation.received":
    "Your order has been received and is being processed. Here are the details:",
  "order_confirmation.order_number": "Order #",
  "order_confirmation.items": "Items",
  "order_confirmation.quantity": "Quantity",
  "order_confirmation.price": "Price",
  "order_confirmation.subtotal": "Subtotal",
  "order_confirmation.shipping": "Shipping",
  "order_confirmation.total": "Total: {amount} SEK",
  "order_confirmation.shipping_note":
    "We will send you another email when your order ships.",
  "order_confirmation.questions":
    "If you have any questions, please don't hesitate to contact us.",
  "order_confirmation.continue_shopping": "Continue Shopping",
  "order_confirmation.shipping_address": "Shipping Address",
  "order_confirmation.address": "Address",
  "order_confirmation.city": "City",
  "order_confirmation.postal_code": "Postal Code",
  "order_confirmation.country": "Country",

  // Admin
  "admin.login.title": "Admin Login",
  "admin.login.subtitle": "Sign in to access the admin panel",
  "admin.login.email": "Email",
  "admin.login.password": "Password",
  "admin.login.sign_in": "Sign In",
  "admin.login.error": "Login failed",
  "admin.login.access_denied": "Access denied. Admin privileges required.",

  "admin.dashboard.title": "Dashboard",
  "admin.dashboard.welcome": "Welcome to the Novi Prints admin panel",
  "admin.dashboard.total_products": "Total Products",
  "admin.dashboard.total_orders": "Total Orders",
  "admin.dashboard.customers": "Customers",
  "admin.dashboard.total_revenue": "Total Revenue",
  "admin.dashboard.active": "active",
  "admin.dashboard.this_week": "this week",
  "admin.dashboard.quick_actions": "Quick Actions",
  "admin.dashboard.create_product": "Create Product",
  "admin.dashboard.view_orders": "View Orders",
  "admin.dashboard.view_customers": "View Customers",
  "admin.dashboard.platform_settings": "Platform Settings",

  "admin.nav.dashboard": "Dashboard",
  "admin.nav.products": "Products",
  "admin.nav.orders": "Orders",
  "admin.nav.customers": "Customers",
  "admin.nav.categories": "Categories",
  "admin.nav.users": "Users",
  "admin.nav.settings": "Settings",
  "admin.nav.sign_out": "Sign Out",

  "admin.products.title": "Products",
  "admin.products.create": "Create Product",
  "admin.products.edit": "Edit Product",
  "admin.products.name": "Name",
  "admin.products.category": "Category",
  "admin.products.price": "Price",
  "admin.products.status": "Status",
  "admin.products.active": "Active",
  "admin.products.inactive": "Inactive",
  "admin.products.actions": "Actions",
  "admin.products.no_products": "No products found",
  "admin.products.no_products_desc":
    "Create your first product to get started.",
  "admin.products.loading": "Loading products...",
  "admin.products.delete_confirm":
    "Are you sure you want to delete this product? This action cannot be undone.",
  "admin.products.delete_success": "Product deleted successfully",
  "admin.products.delete_error": "Failed to delete product",
  "admin.products.toggle_success": "Product status updated",
  "admin.products.toggle_error": "Failed to update product status",
  "admin.products.category_required": "Category *",
  "admin.products.name_en": "Name (English) *",
  "admin.products.name_sv": "Name (Swedish) *",
  "admin.products.description": "Description",
  "admin.products.description_en": "Description (English)",
  "admin.products.description_sv": "Description (Swedish)",
  "admin.products.price_sek": "Price (SEK) *",
  "admin.products.active_label": "Active (visible to customers)",
  "admin.products.images": "Images",
  "admin.products.upload_image": "Upload Image",
  "admin.products.uploading": "Uploading...",
  "admin.products.options": "Options",
  "admin.products.add_option": "Add Option",
  "admin.products.option_name_en": "Option Name (English)",
  "admin.products.option_name_sv": "Option Name (Swedish)",
  "admin.products.option_values": "Values",
  "admin.products.add_value": "Add Value",
  "admin.products.value_en": "English label",
  "admin.products.value_sv": "Swedish label",
  "admin.products.value": "Value",
  "admin.products.remove_option": "Remove Option",
  "admin.products.remove_value": "Remove",
  "admin.products.save": "Save Changes",
  "admin.products.create_btn": "Create Product",
  "admin.products.cancel": "Cancel",
  "admin.products.save_error": "Failed to save product",
  "admin.products.save_success": "Product saved successfully",
  "admin.products.image_url": "Image URL",
  "admin.products.no_image": "No image",
  "admin.products.load_error": "Failed to load product",
  "admin.products.quantity": "Quantity",
  "admin.products.details": "Product Details / Specifications",
  "admin.products.details_en": "Details (English)",
  "admin.products.details_sv": "Details (Swedish)",
  "admin.products.details_placeholder":
    "Enter product details, specifications, features, etc. (HTML supported)",
  "admin.products.details_hint":
    "You can use HTML tags for formatting (e.g., &lt;ul&gt;, &lt;li&gt;, &lt;table&gt;, &lt;strong&gt;, etc.)",
  "admin.products.option": "Product Option",

  "admin.orders.title": "Orders",
  "admin.orders.search": "Search",
  "admin.orders.search_placeholder": "Search by order ID, customer email...",
  "admin.orders.status": "Status",
  "admin.orders.all_statuses": "All Statuses",
  "admin.orders.status.paid": "Paid",
  "admin.orders.status.processing": "Processing",
  "admin.orders.status.shipped": "Shipped",
  "admin.orders.status.delivered": "Delivered",
  "admin.orders.status.cancelled": "Cancelled",
  "admin.orders.order_id": "Order ID",
  "admin.orders.customer": "Customer",
  "admin.orders.items": "Items",
  "admin.orders.total": "Total",
  "admin.orders.date": "Date",
  "admin.orders.no_orders": "No orders found",
  "admin.orders.no_orders_desc":
    "Orders will appear here once customers place them.",
  "admin.orders.loading": "Loading orders...",
  "admin.orders.view": "View Details",
  "admin.orders.update_status": "Update Status",
  "admin.orders.update_status_title": "Update Order Status",
  "admin.orders.new_status": "New Status *",
  "admin.orders.update": "Update Status",
  "admin.orders.update_success": "Order status updated",
  "admin.orders.update_error": "Failed to update status",
  "admin.orders.tracking_url": "Tracking URL",
  "admin.orders.tracking_url_placeholder": "https://tracking.example.com/...",
  "admin.orders.tracking_url_hint":
    "Optional: Add a tracking URL for shipped orders",
  "admin.orders.order_info": "Order Information",
  "admin.orders.shipping_address": "Shipping Address",
  "admin.orders.order_history": "Order History",
  "admin.orders.no_orders_history": "No orders yet.",
  "admin.orders.subtotal": "Subtotal",
  "admin.orders.shipping": "Shipping",
  "admin.orders.item": "item",
  "admin.orders.order": "Order",
  "admin.orders.no_address": "No address provided",

  "admin.customers.title": "Customers",
  "admin.customers.email": "Email",
  "admin.customers.name": "Name",
  "admin.customers.created": "Created",
  "admin.customers.no_customers": "No customers found",
  "admin.customers.no_customers_desc":
    "Customers will appear here once they create an account.",
  "admin.customers.loading": "Loading customers...",
  "admin.customers.view": "View Details",
  "admin.customers.edit": "Edit",
  "admin.customers.delete": "Delete",
  "admin.customers.delete_confirm":
    "Are you sure you want to delete this customer? This action cannot be undone.",
  "admin.customers.delete_success": "Customer deleted successfully",
  "admin.customers.delete_error": "Failed to delete customer",
  "admin.customers.edit_title": "Edit Customer",
  "admin.customers.customer_info": "Customer Information",
  "admin.customers.address": "Address",
  "admin.customers.street": "Street",
  "admin.customers.street2": "Street 2",
  "admin.customers.postal_code": "Postal Code",
  "admin.customers.city": "City",
  "admin.customers.country": "Country",
  "admin.customers.no_address": "No address provided",
  "admin.customers.save": "Save Changes",
  "admin.customers.save_success": "Customer updated successfully",
  "admin.customers.save_error": "Failed to update customer",
  "admin.customers.load_error": "Failed to load customer",
  "admin.customers.customer": "Customer",

  "admin.categories.title": "Categories",
  "admin.categories.create": "Create Category",
  "admin.categories.edit": "Edit Category",
  "admin.categories.name_en": "Name (English) *",
  "admin.categories.name_sv": "Name (Swedish) *",
  "admin.categories.slug": "Slug *",
  "admin.categories.slug_hint": "Lowercase letters, numbers, and hyphens only",
  "admin.categories.image_url": "Image URL",
  "admin.categories.sort_order": "Sort Order",
  "admin.categories.name": "Name",
  "admin.categories.slug_label": "Slug",
  "admin.categories.sort": "Sort Order",
  "admin.categories.no_categories": "No categories found",
  "admin.categories.no_categories_desc":
    "Create your first category to organize products.",
  "admin.categories.loading": "Loading categories...",
  "admin.categories.delete_confirm":
    "Are you sure you want to delete this category? Products in this category will need to be reassigned.",
  "admin.categories.delete_success": "Category deleted successfully",
  "admin.categories.delete_error": "Failed to delete category",
  "admin.categories.save_success": "Category saved successfully",
  "admin.categories.save_error": "Failed to save category",
  "admin.categories.load_error": "Failed to load category",
  "admin.categories.create_error": "Failed to create category",

  "admin.users.title": "Admin Users",
  "admin.users.create": "Create User",
  "admin.users.edit": "Edit User",
  "admin.users.email": "Email",
  "admin.users.name": "Name",
  "admin.users.role": "Role",
  "admin.users.created": "Created",
  "admin.users.no_users": "No users found",
  "admin.users.no_users_desc": "Create your first admin user to get started.",
  "admin.users.loading": "Loading users...",
  "admin.users.delete_confirm":
    "Are you sure you want to delete this user? This action cannot be undone.",
  "admin.users.delete_success": "User deleted successfully",
  "admin.users.delete_error": "Failed to delete user",
  "admin.users.create_title": "Create Admin User",
  "admin.users.password": "Password *",
  "admin.users.password_hint": "Minimum 6 characters",
  "admin.users.create_btn": "Create User",
  "admin.users.create_success": "User created successfully",
  "admin.users.create_error": "Failed to create user",
  "admin.users.save_success": "User updated successfully",
  "admin.users.save_error": "Failed to update user",
  "admin.users.load_error": "Failed to load user",

  "admin.settings.title": "Platform Settings",
  "admin.settings.save": "Save Settings",
  "admin.settings.saved": "Saved!",
  "admin.settings.save_success": "Settings saved successfully",
  "admin.settings.save_error": "Failed to save settings",
  "admin.settings.loading": "Loading settings...",
  "admin.settings.shipping": "Shipping",
  "admin.settings.shipping_rate": "Shipping Rate (SEK) *",
  "admin.settings.gdpr": "GDPR Texts",
  "admin.settings.gdpr_en": "English *",
  "admin.settings.gdpr_sv": "Swedish *",
  "admin.settings.cookie_policy": "Cookie Policy",
  "admin.settings.cookie_en": "English *",
  "admin.settings.cookie_sv": "Swedish *",
  "admin.settings.terms": "Terms & Conditions",
  "admin.settings.terms_en": "English *",
  "admin.settings.terms_sv": "Swedish *",

  "admin.common.loading": "Loading...",
  "admin.common.error": "An error occurred",
  "admin.common.success": "Success!",
  "admin.common.cancel": "Cancel",
  "admin.common.save": "Save",
  "admin.common.edit": "Edit",
  "admin.common.delete": "Delete",
  "admin.common.close": "Close",
  "admin.common.remove": "Remove",
  "admin.common.required": "Required",
  "admin.common.optional": "Optional",
  "admin.common.yes": "Yes",
  "admin.common.no": "No",
  "admin.common.active": "Active",
  "admin.common.inactive": "Inactive",
  "admin.common.select_category": "Select a category",
  "admin.common.failed_to_load": "Failed to load",
  "admin.common.na": "N/A",
};

export default en;
